<div
  class="med_add-member-dialog-wrapper"
  [ngClass]="{ 'multiple-members-vite': selectedFormType === 'multiple', 'is-success-header': addMemberSuccess }"
  data-cy="med_invite_members_modal"
>
  @if (!addMemberSuccess) {
    <ng-container class="modal-body">
      <div class="modal-header d-flex align-items-center justify-content-between">
        <h2 class="xs-title bold">{{ "add_team_member" | translate }}</h2>
        <button
          (click)="closeDialog()"
          type="button"
          class="btn btn-link ms-auto p-0"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <app-icon icon="xmark"></app-icon>
        </button>
      </div>
      <div class="modal-body">
        <!-- Single/Multiple user form toggle -->
        <!-- TODO: Uncomment when feature is required -->
        <!-- <div class="d-flex algin-items-center gap-3 mb-3">
        <div class="d-flex algin-items-center med_checkbox-wrapper d-flex justify-content-center align-items-center"
          [ngClass]="{'selected': selectedFormType === 'single'}">
          <p-radiobutton name="single" value="single" variant="filled" size="small" onclick="changeFormType('single')"
            [(ngModel)]="selectedFormType" />
          <label for="ingredient1" class="ml-2">{{'single_user' | translate}}</label>
        </div>
        <div class="d-flex align-items-center med_checkbox-wrapper d-flex justify-content-center align-items-center"
          [ngClass]="{'selected': selectedFormType === 'multiple'}">
          <p-radiobutton name="multiple" value="multiple" size="small" variant="filled"
            onclick="changeFormType('multiple')" [(ngModel)]="selectedFormType" />
          <label for="ingredient2" class="ml-2">{{'multiple_users' | translate}}</label>
        </div>
      </div> -->
        <!-- #Single/Multiple user form toggle -->

        @if (selectedFormType === "single") {
          <!-- Single user form -->
          <form [formGroup]="addMemberForm">
            <div class="mb-3 d-flex flex-column">
              <label for="email" class="form-label">{{ "hyphenated_email" | translate | titlecase }}</label>
              <input
                formControlName="email"
                type="email"
                class="form-control"
                id="email"
                placeholder="{{ 'enter_email' | translate }}"
                data-cy="med_invite_member_email_input"
              />
              @if (addMemberForm.get("email")?.invalid && addMemberForm.get("email")?.touched) {
                <span class="xs-body text-danger pt-2 animate__animated animate__headShake">{{
                  "email_is_invalid" | translate
                }}</span>
              }
            </div>
            <div class="mb-3 d-flex flex-column">
              <label for="firstName" class="form-label">{{ "first_name" | translate }}</label>
              <input
                formControlName="first_name"
                type="text"
                class="form-control"
                id="firstName"
                placeholder="{{ 'enter_first_name' | translate }}"
                data-cy="med_invite_member_first_name_input"
              />
            </div>
            <div class="mb-3 d-flex flex-column">
              <label for="firstName" class="form-label">{{ "last_name" | translate }}</label>
              <input
                formControlName="last_name"
                type="text"
                class="form-control"
                id="lastName"
                placeholder="{{ 'enter_last_name' | translate }}"
                data-cy="med_invite_member_last_name_input"
              />
            </div>
            <div class="mb-3 d-flex flex-column d-flex flex-column">
              <label for="role" class="form-label">{{ "role" | translate }}</label>
              <p-select
                [options]="userRoles"
                optionValue="value"
                optionLabel="name"
                placeholder="Select Role"
                formControlName="role"
                data-cy="med_invite_member_role_select"
              />
            </div>
          </form>
          <!-- #Single user form -->
        }
        @if (selectedFormType === "multiple") {
          <!-- Multiple user form -->
          <form [formGroup]="multipleMembersForm" (ngSubmit)="onSubmitMultipleUsers()">
            <div formArrayName="users" class="d-flex flex-column gap-3">
              @for (user of users.controls; track user; let i = $index) {
                <div [formGroupName]="i" class="d-flex align-items-start flex-0 gap-3">
                  <div class="d-flex flex-column flex-fill">
                    @if (i < 1) {
                      <label for="first_name" class="form-label">{{ "first_name" | translate }}</label>
                    }
                    <input
                      formControlName="first_name"
                      type="text"
                      class="form-control"
                      [id]="'firstName' + i"
                      placeholder="{{ 'enter_first_name' | translate }}"
                    />
                  </div>
                  <div class="d-flex flex-column flex-fill">
                    @if (i < 1) {
                      <label for="last_name" class="form-label">{{ "last_name" | translate }}</label>
                    }
                    <input
                      formControlName="last_name"
                      type="text"
                      class="form-control"
                      [id]="'lastName' + i"
                      placeholder="{{ 'enter_last_name' | translate }}"
                    />
                  </div>
                  <div class="d-flex flex-column flex-fill">
                    @if (i < 1) {
                      <label for="email" class="form-label">{{ "hyphenated_email" | translate | titlecase }}</label>
                    }
                    <input
                      formControlName="email"
                      type="email"
                      class="form-control"
                      [id]="'email' + i"
                      placeholder="{{ 'enter_email' | translate }}"
                    />
                    @if (
                      users.at(i).get("email")?.invalid &&
                      (users.at(i).get("email")?.dirty || users.at(i).get("email")?.touched)
                    ) {
                      <span class="xs-body text-danger pt-2 animate__animated animate__headShake">{{
                        "email_is_invalid" | translate
                      }}</span>
                    }
                  </div>
                  <button
                    type="button"
                    (click)="removeRow(i)"
                    class="btn btn-link med_remove-row-btn"
                    [disabled]="users.length <= 2"
                  >
                    @if (i > 1) {
                      <app-icon icon="trash-can" [ngClass]="{ 'icon-active': i > 1 }"></app-icon>
                    }
                  </button>
                </div>
              }
            </div>

            <div class="actions mt-3">
              <button
                type="button"
                (click)="addRow()"
                class="btn btn-primary mb-3 med_add-row-btn rounded-circle d-flex justify-content-center align-items-center"
                pTooltip="{{ 'add_another_user' | translate }}"
                showDelay="1000"
                tooltipPosition="top"
              >
                <app-icon icon="plus" class="icon-light"></app-icon>
              </button>
            </div>
          </form>
          <!-- #Multiple user form -->
          <div class="mb-3 d-flex flex-column d-flex flex-column">
            <label for="role" class="form-label">{{ "role" | translate }}</label>
            <span class="fst-italic m-body secondary-color mb-2">
              All members will be assigned the same role, you can change this later in the Members section
            </span>
            <p-select
              [options]="userRoles"
              placeholder="Select Role"
              optionValue="value"
              optionLabel="name"
              [(ngModel)]="multipleUsersSelectedRole"
              class="w-25"
            />
          </div>
        }

        <div class="med_text-box d-flex flex-column justify-content-center align-items-center align-self-stertch">
          @if (workspaceStore.usedSeatsCount() < workspaceStore.originalSeatCount()) {
            @if (addMemberForm.invalid) {
              <p class="l-body animate__animated animate__fadeIn">
                {{ "currently_you_have" | translate }}
                <b
                  >{{ workspaceStore.originalSeatCount() - workspaceStore.usedSeatsCount() }}
                  {{ "available_seats" | translate }}</b
                >
                {{ "in_your_workspace" | translate }}
              </p>
            }
            @if (addMemberForm.valid) {
              <p class="l-body animate__animated animate__fadeIn">
                {{ "after_adding_you_will_have" | translate }}
                <b
                  >{{ workspaceStore.originalSeatCount() - workspaceStore.usedSeatsCount() - 1 }}
                  {{ "seats_available" | translate }}</b
                >
              </p>
            }
          }
          @if (workspaceStore.usedSeatsCount() >= workspaceStore.originalSeatCount()) {
            @if (addMemberForm.invalid) {
              @if (
                subscription?.status === "trialing" && subscription?.subscriptionItem?.quantity <= TRIAL_SEAT_LIMIT
              ) {
                <p class="l-body animate__animated animate__fadeIn">
                  @if (TRIAL_SEAT_LIMIT - subscription?.subscriptionItem?.quantity > 0) {
                    {{
                      "you_dont_have_any_seats_free_trial"
                        | translate
                          : {
                              num_members: TRIAL_SEAT_LIMIT - subscription?.subscriptionItem?.quantity,
                            }
                    }}
                  } @else {
                    {{ "you_dont_have_any_seats_free_trial_none_left" | translate }}
                  }
                </p>
              } @else {
                <p class="l-body animate__animated animate__fadeIn">
                  {{
                    "you_dont_have_any_seats"
                      | translate
                        : {
                            planPrice:
                              (subscription?.subscriptionItem?.price?.unit_amount / 100 | currency: "USD") +
                              subscription?.subscriptionItem?.price?.recurring?.interval,
                          }
                  }}
                </p>
              }
            }
            @if (addMemberForm.valid) {
              @if (
                subscription?.status === "trialing" && subscription?.subscriptionItem?.quantity <= TRIAL_SEAT_LIMIT
              ) {
                @if (TRIAL_SEAT_LIMIT - subscription?.subscriptionItem?.quantity > 0) {
                  <div class="d-flex align-items-center justify-content-between w-100">
                    <span class="xs-title bold">{{ "total_to_pay" | translate }}</span>
                    <span class="xs-title bold">
                      {{ 0.0 | currency: "USD" }}
                    </span>
                  </div>
                  <!-- <div class="d-flex align-items-center justify-content-between w-100">
                <span class="xs-title bold">{{ "total_to_pay_after_trial" | translate }}</span>
                <span class="xs-title bold">
                  {{
                  workspaceStore.companySubscription()?.subscription?.items?.data[0].price.unit_amount / 100
                  | currency : "USD"
                  }}
                </span>
              </div> -->
                } @else {
                  <p class="l-body animate__animated animate__fadeIn">
                    {{ "you_dont_have_any_seats_free_trial_none_left" | translate }}
                  </p>
                }
              } @else {
                <div class="d-flex align-items-center justify-content-between w-100">
                  <span class="xs-title bold">{{ "total_to_pay" | translate }}</span>
                  <span class="xs-title bold">
                    {{ subscription?.subscriptionItem?.price?.unit_amount / 100 | currency: "USD" }}
                  </span>
                </div>
                <p class="l-body animate__animated animate__fadeIn">
                  {{
                    "one_extra_seat_added"
                      | translate
                        : { nextInvoiceDate: formatDate(workspaceStore.nextInvoice()?.period_end, "Do MMMM YYYY") }
                  }}
                </p>
              }
            }
          }
        </div>
      </div>

      <div class="modal-footer">
        @if (selectedFormType === "single") {
          <button
            class="btn btn-primary w-100 m-auto med_action-btn"
            (click)="addTeamMember()"
            [disabled]="
              addMemberForm.invalid ||
              (subscription?.status === 'trialing' && workspaceStore.usedSeatsCount() >= TRIAL_SEAT_LIMIT)
            "
            data-cy="med_invite_member_submit_btn"
          >
            {{ "add_member" | translate }}
          </button>
        }
        @if (selectedFormType === "multiple") {
          <button
            class="btn btn-primary w-100 m-auto med_action-btn"
            (click)="onSubmitMultipleUsers()"
            [disabled]="multipleMembersForm.invalid || !multipleUsersSelectedRole"
          >
            {{ "add_members" | translate }}
          </button>
        }
      </div>
    </ng-container>
  }
  <!-- Add seats success -->
  @if (addMemberSuccess) {
    <ng-container>
      <div class="d-flex flex-column align-items-center w-100 med_success-modal-header">
        <button
          (click)="closeDialog()"
          type="button"
          class="btn btn-link ms-auto p-0"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <app-icon icon="xmark"></app-icon>
        </button>
        <div class="checkmark-icon-wrapper d-block m-auto">
          <img src="assets/images/circle-check-gradient-border.svg" alt="" />
        </div>
      </div>
      <div class="modal-body">
        <h4 class="m-title info-color text-left pt-4" data-cy="med_workspace_invite_success_txt">
          {{ "great_seats_added_and_assigned" | translate: { newSeatCount: 1 } }}
        </h4>
        <p class="l-body text-left mt-2 mb-3">
          <span class="bold">{{ addMemberForm.value.first_name }}</span> {{ "now_has_a_seat" | translate }}
        </p>
        <div class="workspace_seats_progress pb-3">
          <p class="m-body bold">{{ "company_seats" | translate }}</p>
          <br />
          <div class="d-flex justify-content-between align-items-center w-100">
            <p class="m-body">
              {{ workspaceStore.originalSeatCount() }}
              {{ "seats" | translate }}
            </p>
            <p class="m-body">
              {{ workspaceStore.originalSeatCount() - workspaceStore.usedSeatsCount() }}
              {{ "available" | translate }}
            </p>
          </div>
          <br />
          <mat-progress-bar
            mode="determinate"
            [value]="(workspaceStore.usedSeatsCount() / workspaceStore.originalSeatCount()) * 100"
          >
          </mat-progress-bar>
        </div>

        @if (subscription?.status !== "trialing") {
          <div class="med_bordered-box d-flex flex-column gap-1">
            <span class="l-body"
              >{{ "next_invoice" | translate }}:
              {{ formatDate(workspaceStore.nextInvoice()?.current_period_end, "Do MMMM YYYY") }}
            </span>
            <span class="l-body">{{ subscription?.subscriptionItem?.price?.product?.name }}</span>
            <div class="med_seats-pill d-flex justify-content-start allign-items-center gap-1">
              <app-icon icon="chair-office" />
              <p class="l-body">{{ workspaceStore.originalSeatCount() }} {{ "seats" | translate }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <span class="xl-body bold">
                {{ "invoice_amount" | translate }}
              </span>
              <span class="xl-body bold">
                {{ workspaceStore.nextInvoice()?.amount_due / 100 | currency: "USD" }}
              </span>
            </div>
          </div>
        }
      </div>

      <div class="modal-footer border-0">
        <button class="btn btn-primary w-100" (click)="closeDialog()" data-cy="med_invite_members_success_close_btn">
          {{ "close" | translate }}
        </button>
      </div>
    </ng-container>
  }
  <!-- #Add seats success -->
</div>
